export enum ClientType {
  person = 1,
  company = 2,
}

export const ClientTypeNameMap = {
  [ClientType.person]: 'person',
  [ClientType.company]: 'company',
};
